/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useState, useReducer, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { TableCell, Grid, DialogContentText } from '@material-ui/core';
import { Table, Filtro, UploadDialog, DialogDefault, ButtonMenu } from '../../components';
import * as selectorsAuth from '../../store/auth/reducer';
import * as selectorsFiltro from '../../store/filtro/reducer';
import * as actionsNsirs from '../../store/nsir/actions';
import * as actionsToast from '../../store/toast/actions';
import * as actionsLoader from '../../store/loader/actions';
import * as Role from '../../constants/role';
import * as XLSX from 'xlsx';
import * as Status from '../../constants/status';
import { canCloneAuditoriaFaixa, isUsuarioUsoMuto } from 'utils';
import {
  EquipamentoNsirCell,
  CtPlanExecCell,
  MalhaRegionalAlimentadorCell,
  TipoServicoCell,
  DatasCell,
  AreaCell,
  TextCell,
} from './components/TableCells';
import ImportValidationModal from './components/ImportValidationModal';
import {
  getDefaultFilter,
  getStatusOptionsByRole,
  DIALOG_TYPES,
  ERROR_MESSAGES,
  EXPORT_MESSAGES,
  DEFAULT_STATUS,
  DEFAULT_DATE_TYPES,
  DIGITADOR_DIARIO_ALLOWED_EMAILS,
} from './constants';

const dialogReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN':
      return { ...state, [action.dialogType]: true };
    case 'CLOSE':
      return { ...state, [action.dialogType]: false };
    case 'CLOSE_ALL':
      return Object.keys(state).reduce((acc, key) => ({ ...acc, [key]: false }), {});
    default:
      return state;
  }
};

const initialDialogState = {
  [DIALOG_TYPES.IMPORT]: false,
  [DIALOG_TYPES.IMPORT_NSMPS]: false,
  [DIALOG_TYPES.IMPORT_FINANCEIRO]: false,
  [DIALOG_TYPES.IMPORT_DIGITADOR]: false,
  [DIALOG_TYPES.IMPORT_PREVIEW]: false,
  [DIALOG_TYPES.EXPORT]: false,
  [DIALOG_TYPES.EXPORT_EDIT]: false,
  [DIALOG_TYPES.EXPORT_SERVICO]: false,
  [DIALOG_TYPES.EXPORT_FINANCEIRO]: false,
  [DIALOG_TYPES.EXPORT_DIGITADOR]: false,
  [DIALOG_TYPES.EXPORT_INSPECAO]: false,
  [DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO]: false,
  [DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO]: false,
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
  },
  tableCell: {
    fontSize: 12,
    padding: theme.spacing(1.5),
    verticalAlign: 'top',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    transition: 'background-color 0.2s ease',
  },
  filterContainer: {
    marginBottom: theme.spacing(2),
  },
}));

const Nsirs = ({
  importNsirs,
  history,
  cleanSelectedNsir,
  userRole,
  authData,
  messageError,
  deleteNsir,
  exportNsirs,
  cacheFiltroNsir,
  importNsirServices,
  exportToEditNsirs,
  exportFinanceiro,
  importNsirFinanceiro,
  nsirExport,
  defaultNsirImport,
  previewNsirImport,
  generateNsirReport,
  generateInspecaoReport,
  generateReportUsoMutuo,
  generateReportDigitadorDiario,
  showLoader,
  hideLoader,
  cloneNsir,
}) => {
  const classes = useStyles();
  const [dialogs, dispatchDialog] = useReducer(dialogReducer, initialDialogState);
  const [localFilter, setLocalFilter] = useState({});
  const [importLoading, setImportLoading] = useState(false);
  const [importPreview, setImportPreview] = useState(null);
  const [importRawData, setImportRawData] = useState(null);
  const [importedFile, setImportedFile] = useState(null);
  const [openClone, setOpenClone] = useState(false);
  const [cloneId, setCloneId] = useState(null);

  const optionsStatus = useMemo(
    () => getStatusOptionsByRole(userRole),
    [userRole]
  );

  const defaultFilter = useMemo(
    () => getDefaultFilter(authData.email, isUsuarioUsoMuto),
    [authData.email]
  );

  useEffect(() => {
    if (Object.keys(cacheFiltroNsir).length > 0) {
      setLocalFilter(cacheFiltroNsir);
    } else {
      setLocalFilter(defaultFilter);
    }
  }, [cacheFiltroNsir, defaultFilter]);

  const openDialog = useCallback((dialogType) => {
    dispatchDialog({ type: 'OPEN', dialogType });
  }, []);

  const closeDialog = useCallback((dialogType) => {
    dispatchDialog({ type: 'CLOSE', dialogType });
  }, []);

  const renderRows = useCallback((d) => {
    return (
      <>
        <TableCell size="small" className={classes.tableCell}>
          <EquipamentoNsirCell data={d} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <TipoServicoCell data={d} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <AreaCell data={d} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <CtPlanExecCell data={d} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <MalhaRegionalAlimentadorCell data={d} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <TextCell value={d.inspetor} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <TextCell value={d.digitador} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <TextCell value={d.statusName} />
        </TableCell>
        <TableCell size="small" className={classes.tableCell}>
          <DatasCell data={d} />
        </TableCell>
      </>
    );
  }, [classes.tableCell]);

  const onEdit = useCallback((id) => {
    cleanSelectedNsir();
    history.push(`/nsir/${id}`);
  }, [cleanSelectedNsir, history]);

  const onAdd = useCallback(() => {
    cleanSelectedNsir();
    history.push('/nsir');
  }, [cleanSelectedNsir, history]);

  const onDelete = useCallback((id, callback) => {
    deleteNsir(id, callback);
  }, [deleteNsir]);

  const headerActions = useMemo(() => {
    if (isUsuarioUsoMuto(authData.email)) {
      return [{
        isComponent: true,
        component: (
          <ButtonMenu
            title="Exportar"
            aria-label="Menu de exportação"
            options={[
              {
                title: "Uso Mútuo",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
            ]}
          />
        ),
      }];
    }

    return [
      {
        isComponent: true,
        component: (
          <ButtonMenu
            title="Importar"
            aria-label="Menu de importação"
            options={[
              {
                title: "NSIRs",
                onClick: () => openDialog(DIALOG_TYPES.IMPORT),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Serviços",
                onClick: () => openDialog(DIALOG_TYPES.IMPORT_NSMPS),
                show: Role.CROQUI !== userRole && Role.DIGITADOR !== userRole,
              },
              {
                title: "Financeiro",
                onClick: () => openDialog(DIALOG_TYPES.IMPORT_FINANCEIRO),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Digitadores",
                onClick: () => openDialog(DIALOG_TYPES.IMPORT_DIGITADOR),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
            ]}
          />
        ),
      },
      {
        isComponent: true,
        component: (
          <ButtonMenu
            title="Exportar"
            aria-label="Menu de exportação"
            options={[
              {
                title: "NSIRs",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT),
                show: true,
              },
              {
                title: "P/ Edição",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_EDIT),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Financeiro",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_FINANCEIRO),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Digitadores",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_DIGITADOR),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Serviços",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_SERVICO),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Inspeção",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_INSPECAO),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Uso Mútuo",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO),
                show: Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole,
              },
              {
                title: "Digitadores Diário",
                onClick: () => openDialog(DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO),
                show: DIGITADOR_DIARIO_ALLOWED_EMAILS.includes(authData.email),
              },
            ]}
          />
        ),
      },
    ];
  }, [authData.email, userRole, openDialog]);

  const handleFileImport = useCallback(async (files, importFn, sheetName, dialogType, errorMessage) => {
    if (!files || files.length === 0) {
      messageError({ message: 'Nenhum arquivo selecionado.' });
      return;
    }

    setImportLoading(true);
    showLoader();

    try {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const workbook = XLSX.read(e.target.result, { type: 'binary' });

          if (!workbook.SheetNames.includes(sheetName)) {
            messageError({ message: errorMessage });
            setImportLoading(false);
            hideLoader();
            return;
          }

          const nsirs = [];
          const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 }).slice(1);
          
          for (const row of excelData) {
            if (row.length > 0) {
              nsirs.push(row);
            }
          }

          if (nsirs.length === 0) {
            messageError({ message: 'A planilha está vazia ou não contém dados válidos.' });
            setImportLoading(false);
            hideLoader();
            return;
          }

          importFn({ nsirs }, () => {
            closeDialog(dialogType);
            setImportLoading(false);
            hideLoader();
          });
        } catch (parseError) {
          console.error('Error parsing file:', parseError);
          messageError({ message: ERROR_MESSAGES.READ_ERROR });
          setImportLoading(false);
          hideLoader();
        }
      };

      reader.onerror = () => {
        messageError({ message: ERROR_MESSAGES.READ_ERROR });
        setImportLoading(false);
        hideLoader();
      };

      reader.readAsBinaryString(files[0]);
    } catch (error) {
      console.error('Error reading file:', error);
      messageError({ message: ERROR_MESSAGES.READ_ERROR });
      setImportLoading(false);
      hideLoader();
    }
  }, [messageError, showLoader, hideLoader, closeDialog]);

  const onImport = useCallback((files) => {
    const selectedFile = files && files[0] ? files[0] : null;
    handleFileImport(
      files,
      (data, done) => {
        previewNsirImport(data, (preview) => {
          setImportPreview(preview);
          setImportRawData(data);
          setImportedFile(selectedFile);
          openDialog(DIALOG_TYPES.IMPORT_PREVIEW);
          done();
        });
      },
      'Nsirs',
      DIALOG_TYPES.IMPORT,
      ERROR_MESSAGES.INVALID_SHEET
    );
  }, [handleFileImport, previewNsirImport, openDialog]);

  const onConfirmImport = useCallback((selectedLines) => {
    const normalizedSelectedLines = (selectedLines || []).filter(Number.isInteger);
    if (normalizedSelectedLines.length === 0) {
      messageError({ message: 'Selecione ao menos uma linha valida para importar.' });
      return;
    }

    if (!importPreview || !importPreview.previewToken) {
      messageError({ message: 'Token de validacao expirado. Faça uma nova importacao.' });
      return;
    }

    importNsirs({
      previewToken: importPreview.previewToken,
      selectedLines: normalizedSelectedLines,
    }, () => {
      closeDialog(DIALOG_TYPES.IMPORT_PREVIEW);
      setImportPreview(null);
      setImportRawData(null);
      setImportedFile(null);
    });
  }, [importNsirs, importPreview, closeDialog, messageError]);

  const onDownloadImportedFile = useCallback(() => {
    if (importedFile) {
      const downloadUrl = URL.createObjectURL(importedFile);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = importedFile.name || 'planilha-importada.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
      return;
    }

    if (!importRawData || !Array.isArray(importRawData.nsirs) || importRawData.nsirs.length === 0) {
      messageError({ message: 'Nao foi possivel recuperar a planilha importada.' });
      return;
    }

    const worksheet = XLSX.utils.aoa_to_sheet(importRawData.nsirs);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Nsirs');
    XLSX.writeFile(workbook, 'planilha-importada.xlsx');
  }, [importedFile, importRawData, messageError]);

  const onNewImport = useCallback(() => {
    closeDialog(DIALOG_TYPES.IMPORT_PREVIEW);
    setImportPreview(null);
    setImportRawData(null);
    setImportedFile(null);
    openDialog(DIALOG_TYPES.IMPORT);
  }, [closeDialog, openDialog]);

  const onImportFinanceiro = useCallback((files) => {
    handleFileImport(
      files,
      importNsirFinanceiro,
      'NSIRs Financeiro',
      DIALOG_TYPES.IMPORT_FINANCEIRO,
      ERROR_MESSAGES.INVALID_SHEET
    );
  }, [handleFileImport, importNsirFinanceiro]);

  const onImportDigitadores = useCallback((files) => {
    handleFileImport(
      files,
      (data, callback) => defaultNsirImport("import/digitadores", data, callback),
      'NSIRs Digitadores',
      DIALOG_TYPES.IMPORT_DIGITADOR,
      ERROR_MESSAGES.INVALID_DIGITADOR_SHEET
    );
  }, [handleFileImport, defaultNsirImport]);

  const onImportNsmps = useCallback((files) => {
    if (!files || files.length === 0) {
      messageError({ message: 'Nenhum arquivo selecionado.' });
      return;
    }

    setImportLoading(true);
    showLoader();

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const nsirData = JSON.parse(e.target.result);
        
        if (!nsirData.nsir || !nsirData.nsmps || !nsirData.fotos) {
          messageError({ message: ERROR_MESSAGES.INVALID_FILE });
          setImportLoading(false);
          hideLoader();
          return;
        }

        importNsirServices(nsirData, () => {
          closeDialog(DIALOG_TYPES.IMPORT_NSMPS);
          setImportLoading(false);
          hideLoader();
        });
      } catch (parseError) {
        console.error('Error parsing JSON file:', parseError);
        messageError({ message: ERROR_MESSAGES.INVALID_FILE });
        setImportLoading(false);
        hideLoader();
      }
    };

    reader.onerror = () => {
      messageError({ message: ERROR_MESSAGES.READ_ERROR });
      setImportLoading(false);
      hideLoader();
    };

    reader.readAsText(files[0]);
  }, [messageError, showLoader, hideLoader, importNsirServices, closeDialog]);

  const onExport = useCallback(() => {
    const exportHandlers = {
      [DIALOG_TYPES.EXPORT_EDIT]: () => exportToEditNsirs(localFilter, () => closeDialog(DIALOG_TYPES.EXPORT_EDIT)),
      [DIALOG_TYPES.EXPORT]: () => exportNsirs(localFilter, () => closeDialog(DIALOG_TYPES.EXPORT)),
      [DIALOG_TYPES.EXPORT_FINANCEIRO]: () => exportFinanceiro(localFilter, () => closeDialog(DIALOG_TYPES.EXPORT_FINANCEIRO)),
      [DIALOG_TYPES.EXPORT_DIGITADOR]: () => nsirExport("export/digitadores", "RelatórioDigitadores.xlsx", localFilter, () => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR)),
      [DIALOG_TYPES.EXPORT_SERVICO]: () => generateNsirReport(localFilter, () => closeDialog(DIALOG_TYPES.EXPORT_SERVICO)),
      [DIALOG_TYPES.EXPORT_INSPECAO]: () => generateInspecaoReport(localFilter, () => closeDialog(DIALOG_TYPES.EXPORT_INSPECAO)),
      [DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO]: () => generateReportUsoMutuo(localFilter, () => closeDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO)),
      [DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO]: () => generateReportDigitadorDiario({}, () => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO)),
    };

    const activeDialog = Object.keys(dialogs).find(key => dialogs[key] === true);
    if (activeDialog && exportHandlers[activeDialog]) {
      exportHandlers[activeDialog]();
    }
  }, [localFilter, dialogs, closeDialog, exportToEditNsirs, exportNsirs, exportFinanceiro, nsirExport, generateNsirReport, generateInspecaoReport, generateReportUsoMutuo, generateReportDigitadorDiario]);

  const tableTitles = useMemo(() => [
    'NSIR e Equipamento',
    'Tipo Serviço',
    'Área',
    'CT. Plan e Exec',
    'Malha/Regional e Alimentador',
    'Inspetor',
    'Digitador',
    'Status',
    'Datas',
  ], []);

  const defaultTipoServico = useMemo(
    () => isUsuarioUsoMuto(authData.email) ? ["374aa79b-0ce2-4b45-9c55-ae20ec5c5e27"] : null,
    [authData.email]
  );

  const handleClearFilters = useCallback(() => {
    setLocalFilter(defaultFilter);
  }, [defaultFilter]);

  return (
    <>
      <Grid container>
        <Grid item xs={12} className={classes.filterContainer}>
          <Filtro
            onFilter={setLocalFilter}
            codigoLabel="Nsir"
            useDates
            useCodigo
            useEquipamento
            useInspetor
            useDigitador
            useMalha
            useGerencia
            usePolo
            useSubestacao
            useAlimentador
            useNsirStatus
            multipleStatus
            useCtPlan
            useCtExec
            usePossuiCroqui
            useNsirPagaInspetor
            useApro
            useHd
            possuiHd
            possuiApro
            useNumNsmp
            usePrioridade
            useInspecaoTermografica
            useTipoServico
            useCliente
            defaultStatus={DEFAULT_STATUS}
            optionsStatus={optionsStatus}
            useDateTypes
            useAdere
            defaultDateTypes={DEFAULT_DATE_TYPES}
            defaultTipoServico={defaultTipoServico}
          />
        </Grid>
        <Grid item xs={12} className={classes.root}>
          <Table
            titles={tableTitles}
            headerTitle="NSIRs"
            renderRows={renderRows}
            hasRowActions
            showEdit={!isUsuarioUsoMuto(authData.email)}
            showView={isUsuarioUsoMuto(authData.email)}
            onEdit={onEdit}
            onView={onEdit}
            onAdd={onAdd}
            showDelete={Role.ADMIN === userRole && !isUsuarioUsoMuto(authData.email)}
            onDelete={onDelete}
            hasAdd={Role.ADMIN === userRole && !isUsuarioUsoMuto(authData.email)}
            headerActions={headerActions}
            useFilterData
            usePaginationApi
            paginationApi="nsirs/filter"
            paginationUrl="nsirs"
            filterData={localFilter}
            showLoader={showLoader}
            hideLoader={hideLoader}
            onClearFilters={handleClearFilters}
            actions={
              [
                {
                  key: 'clone',
                  icon: <FileCopyIcon />,
                  show: (row) => canCloneAuditoriaFaixa(authData.id, row.tipoServicoId) && Status.canCloneAuditoriaFaixa(row.status),
                  onClick: id => {
                    setOpenClone(true);
                    setCloneId(id);
                  }
                },
              ]
            }
          />
        </Grid>
      </Grid>
      
      <UploadDialog
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT)}
        onSave={onImport}
        open={dialogs[DIALOG_TYPES.IMPORT]}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar NSIRs"
        aria-label="Dialog de importação de NSIRs"
      />
      <ImportValidationModal
        open={dialogs[DIALOG_TYPES.IMPORT_PREVIEW]}
        preview={importPreview}
        onCancel={() => {
          closeDialog(DIALOG_TYPES.IMPORT_PREVIEW);
          setImportPreview(null);
          setImportRawData(null);
          setImportedFile(null);
        }}
        onConfirm={onConfirmImport}
        onNewImport={onNewImport}
        importedFileName={importedFile ? importedFile.name : ''}
        onDownloadImportedFile={onDownloadImportedFile}
      />
      <UploadDialog
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT_NSMPS)}
        onSave={onImportNsmps}
        open={dialogs[DIALOG_TYPES.IMPORT_NSMPS]}
        acceptedFiles={['.json']}
        dialogTitle="Importar Serviços"
        aria-label="Dialog de importação de serviços"
      />
      <UploadDialog
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT_FINANCEIRO)}
        onSave={onImportFinanceiro}
        open={dialogs[DIALOG_TYPES.IMPORT_FINANCEIRO]}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar Financeiro"
        aria-label="Dialog de importação financeiro"
      />
      <UploadDialog
        onClose={() => closeDialog(DIALOG_TYPES.IMPORT_DIGITADOR)}
        onSave={onImportDigitadores}
        open={dialogs[DIALOG_TYPES.IMPORT_DIGITADOR]}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar Digitadores"
        aria-label="Dialog de importação de digitadores"
      />
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação"
      >
        <DialogContentText>{EXPORT_MESSAGES.NSIRS}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_EDIT]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_EDIT)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação para edição"
      >
        <DialogContentText>{EXPORT_MESSAGES.EDIT}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_SERVICO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_SERVICO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação de serviços"
      >
        <DialogContentText>{EXPORT_MESSAGES.SERVICO}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_INSPECAO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_INSPECAO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação de inspeção"
      >
        <DialogContentText>{EXPORT_MESSAGES.INSPECAO}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_FINANCEIRO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_FINANCEIRO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação financeiro"
      >
        <DialogContentText>{EXPORT_MESSAGES.FINANCEIRO}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_DIGITADOR]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação de digitadores"
      >
        <DialogContentText>{EXPORT_MESSAGES.DIGITADOR}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_REPORT_USO_MUTUO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação de uso mútuo"
      >
        <DialogContentText>{EXPORT_MESSAGES.USO_MUTUO}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={dialogs[DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO]}
        handlerCancel={() => closeDialog(DIALOG_TYPES.EXPORT_DIGITADOR_DIARIO)}
        handlerConfirm={onExport}
        title="Confirmação"
        confirmMessage="Exportar"
        aria-label="Dialog de confirmação de exportação de digitadores diário"
      >
        <DialogContentText>{EXPORT_MESSAGES.DIGITADOR_DIARIO}</DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={openClone}
        handlerCancel={() => { setOpenClone(false); setCloneId(null); }}
        handlerConfirm={() => {
          setOpenClone(true);
          cloneNsir(cloneId, () => {
            setCloneId(null);
            setOpenClone(false);
            window.location.reload();
          });
        }}
        title="Você tem certeza que deseja clonar o serviço?"
        confirmMessage="Clonar"
      >
        <DialogContentText> Ao clonar o serviço, todas as informações e fotos serão duplicadas. O novo serviço terá um novo código. </DialogContentText>
      </DialogDefault>
    </>
  );
};

Nsirs.propTypes = {
  importNsirs: PropTypes.func.isRequired,
  cleanSelectedNsir: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  userRole: PropTypes.string.isRequired,
  authData: PropTypes.object.isRequired,
  messageError: PropTypes.func.isRequired,
  deleteNsir: PropTypes.func.isRequired,
  exportNsirs: PropTypes.func.isRequired,
  cacheFiltroNsir: PropTypes.object.isRequired,
  importNsirServices: PropTypes.func.isRequired,
  exportToEditNsirs: PropTypes.func.isRequired,
  exportFinanceiro: PropTypes.func.isRequired,
  importNsirFinanceiro: PropTypes.func.isRequired,
  nsirExport: PropTypes.func.isRequired,
  defaultNsirImport: PropTypes.func.isRequired,
  previewNsirImport: PropTypes.func.isRequired,
  generateNsirReport: PropTypes.func.isRequired,
  generateInspecaoReport: PropTypes.func.isRequired,
  generateReportUsoMutuo: PropTypes.func.isRequired,
  generateReportDigitadorDiario: PropTypes.func.isRequired,
  showLoader: PropTypes.func.isRequired,
  hideLoader: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  userRole: selectorsAuth.getRole(state),
  authData: selectorsAuth.getAuth(state),
  cacheFiltroNsir: selectorsFiltro.getCacheFiltroNsir(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsirs,
      ...actionsToast,
      ...actionsLoader,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Nsirs));
